import { useEffect } from "react";

interface SchemaOrgProps {
  type: "organization" | "website" | "webpage" | "breadcrumb" | "article" | "faqpage";
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const id = `schema-${type}`;
    let script = document.getElementById(id) as HTMLScriptElement;
    if (!script) {
      script = document.createElement("script");
      script.id = id;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      ...data,
    });
  }, [type, data]);

  return null;
}